import constants from './constants';

export const TOP_PINNED_DROPDOWN_VALUES =
    constants.COMPONENTS.DROPDOWN.TOP_PINNED_VALUES;
export const BOTTOM_PINNED_DROPDOWN_VALUES =
    constants.COMPONENTS.DROPDOWN.BOTTOM_PINNED_VALUES;

export const getSortLabel = (option) => {
    const label = option?.label;
    if (typeof label === 'string' || typeof label === 'number') {
        return String(label);
    }
    return '';
};

export const getOptionMatchKeys = (option) => {
    const keys = [option?.value, option?.name, option?.id, option?.label]
        .filter((key) => key !== undefined && key !== null)
        .map((key) => String(key));

    return [...new Set(keys)];
};

const matchesPinnedValue = (option, pinnedValues) =>
    getOptionMatchKeys(option).some((key) => pinnedValues.includes(key));

export const isTopPinnedOption = (option) =>
    matchesPinnedValue(option, TOP_PINNED_DROPDOWN_VALUES);

export const isBottomPinnedOption = (option) =>
    matchesPinnedValue(option, BOTTOM_PINNED_DROPDOWN_VALUES);

export const isPinnedDropdownOption = (option) =>
    isTopPinnedOption(option) || isBottomPinnedOption(option);

export const sortOptionsByLabel = (
    options = [],
    { sortOptionsAlphabetically = true } = {}
) => {
    if (!sortOptionsAlphabetically || !options?.length) {
        return options;
    }

    const topPinned = [];
    const sortable = [];
    const bottomPinned = [];

    options.forEach((option) => {
        if (isTopPinnedOption(option)) {
            topPinned.push(option);
        } else if (isBottomPinnedOption(option)) {
            bottomPinned.push(option);
        } else {
            sortable.push(option);
        }
    });

    sortable.sort((a, b) =>
        getSortLabel(a).localeCompare(getSortLabel(b), undefined, {
            sensitivity: 'base',
            numeric: true,
        })
    );

    return [...topPinned, ...sortable, ...bottomPinned];
};
